<template>
  <div
    class="specialcar-calendar"
    :class="{'is-mobile': breakpoint <= BREAKPOINT_SM}"
  >
    <div class="d-flex align-center mb-4">
      <div class="month">{{monthText}}</div>
      <v-btn
        fab x-small
        color="primary"
        elevation="1"
        class="ml-2 ml-md-4"
        :disabled="month <= monthRange.first"
        @click="onMoveMonth(-1)"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-btn
        fab x-small
        color="primary"
        elevation="1"
        class="ml-2 ml-md-4"
        :disabled="month >= monthRange.last"
        @click="onMoveMonth(1)"
      >
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>

      <v-spacer/>

      <div class="legend is-holiday">定休日</div>
    </div>

    <v-calendar
      type="month" locale="jp-ja" color="primary"
      :value="month"
    >
      <template #day-label>
        <div />
      </template>

      <template #day="{date, day}">
        <car-calendar-cell
          :date="date"
          :day="day"
          :value="days[date]"
          @selected="onSelected"
        />
      </template>
    </v-calendar>
  </div>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.specialcar-calendar {
  .v-calendar-monthly.v-calendar.theme--light {
    .v-calendar-weekly__head {
      .v-calendar-weekly__head-weekday {
        background-color: $table-th-color;
        color: white !important;
        line-height: 32px;
      }
    }
    .v-calendar-weekly__week {
      flex-basis: auto;
    }
    .v-calendar-weekly__day-label {
      display: none;
    }
  }

  .legend {
    @extend %typo-caption;

    padding: .25rem 1rem;
    margin-left: .25rem;
    min-width: 4rem;
    text-align: center;

    color: white;
    font-weight: 700;
  }
  .legend.is-holiday {
    background-color: #66BB6A;
    border: 1px solid #e0e0e0;
  }
}

.specialcar-calendar.is-mobile {
  .legend {
    @extend %typo-caption;

    padding: .25rem;
  }
}
</style>

<script>
import PartBase from '@/mixins/PartBase'
import CarCalendarCell from './CarCalendarCell'
import * as time from '@/libs/time'

export default {
  name: 'CarCalendar',
  mixins: [
    PartBase
  ],
  components: {
    CarCalendarCell
  },
  props: {
    month: {
      type: String,
      required: true
    },
    monthRange: {
      type: Object,
      required: true
    },
    days: {
      type: Object,
      required: true
    }
  },
  computed: {
    monthText () {
      return time.format('Y年m月', this.month)
    }
  },
  methods: {
    //
    // 月度の移動ボタンが押された
    //
    onMoveMonth (delta) {
      this.$emit('movemonth', delta)
    },

    onSelected (date, item) {
      // period (その日の利用可能期間) を得る
      const begin = time.join(date, item.begin.time)
      const end = time.join(date, item.end.time)

      this.$emit('selected', {
        allow: item.range,
        period: { begin, end }
      })
    }
  }
}
</script>
